import React, { Component } from 'react';
import logo from './LogoNavionics.svg';
import './LogoNavionics.scss';

export default class LogoNavionics extends Component {
  render() {
    return <img src={logo} className="Nav-logo" alt="logo" />;
  }
}
